import React from 'react';
import styled from 'styled-components';

const VideoWrapper = styled.div`
  position: relative;
  width: 100%;
  padding-bottom: 56.25%; /* 16:9 aspect ratio */
  height: 0;
  overflow: hidden;
  background: #000;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.5);

  video, iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: none;
  }

  video {
    object-fit: contain;
    background: #000;
  }
`;

const VideoTitle = styled.h3`
  color: #00d4ff;
  margin: 12px 0 8px;
  font-size: 1.3rem;
  text-align: center;
`;

const VideoPlayer = ({ src, title, isEmbed = false, controls = true }) => {
  if (!src) return null;

  return (
    <>
      <VideoWrapper>
        {isEmbed ? (
          // For Rumble / YouTube embeds → keep iframe
          <iframe
            src={src}
            title={title || 'Embedded video'}
            allowFullScreen
            allow="autoplay; fullscreen; picture-in-picture"
          />
        ) : (
          // For self-hosted MP4 files → use native <video>
          <video
            controls={controls}
            preload="metadata"
            playsInline
            autoPlay={false}
            muted={false}
          >
            <source src={src} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        )}
      </VideoWrapper>

      {title && <VideoTitle>{title}</VideoTitle>}
    </>
  );
};

export default VideoPlayer;